import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import App from './components/App';
import _debug from 'debug';
import configureStore from 'common/redux/configureStore';
import { getIsDirty } from './reducers/dirty';
import { getManipState } from './reducers/manips';
import {
  getCreatedManips,
  getUpdatedManips,
  getDeletedManips,
} from './reducers/manips';
import $ from 'jquery';

const debug = _debug('app::manipulations');

export default function(interventionId, siteCaseId) {
  const root = document.getElementById('manipulations');
  if (root) {
    debug(`Rendering manipulations for intervention ${interventionId}`);

    // Retrieving context data
    const type = root.dataset.type;
    const customer = root.dataset.customer;
    const site = root.dataset.site;
    const siteCase = root.dataset.sitecase;
    const disabled = root.dataset.disabled === 'true';
    const taskId = root.dataset.task;

    const store = configureStore();
    ReactDOM.render(
      <Provider store={store}>
        <App
          intervention={interventionId}
          customer={customer}
          site={site}
          siteCase={siteCase}
          type={type}
          disabled={disabled}
          taskId={taskId}
        />
      </Provider>,
      root
    );

    const dirtyHandler = () => {
      if (getIsDirty(store.getState())) {
        $('form.ui.form').addClass('dirty');
      }
    };

    store.subscribe(dirtyHandler);

    const $preInstallInput = $('input[name="preinstall-hidden"]');
    if ($preInstallInput && $preInstallInput.length) {
      const productManipHandler = () => {
        const manipState = getManipState(store.getState());
        $preInstallInput.val(manipState);
      };

      store.subscribe(productManipHandler);
    }

    return store;
  }

  return null;
}

export const serializeForm = $form => new FormData($form[0]);

export const serializeStore = store => {
  if (store) {
    const state = store.getState();

    const serialized = {};
    serialized['created'] = getCreatedManips(state);
    serialized['updated'] = getUpdatedManips(state);
    serialized['deleted'] = getDeletedManips(state);

    return serialized;
  }

  console.log('Trying to serialize an empty store');
  return null;
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/index.js